import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Loader from './Loader';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const { isAuthenticated, loading, user } = useAuth(); // Extracted 'user' to check roles
    const location = useLocation();

    // 1. Wait for auth check to finish
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <Loader />
            </div>
        );
    }

    // 2. If not logged in, redirect to login page
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 3. Role-Based Access Control (RBAC) Check
    // If specific roles are required, and the user's role is not in the list, kick them out
    if (allowedRoles.length > 0 && user && !allowedRoles.includes(user.role)) {
        console.warn(`Access Denied: User role '${user.role}' lacks permission for this route.`);
        // Redirect unauthorized users to the main dashboard
        return <Navigate to="/admin" replace />; 
    }

    // 4. Authorized -> Render the component
    return children;
};

export default ProtectedRoute;